import { useContext } from "react";
import { SsrLdFlagsContext } from "../components/ssr-ld-flags-provider";

const useSsrLdFlag = (flagName, defaultValue = false) => {
  const ssrLdFlags = useContext(SsrLdFlagsContext);
  const { [flagName]: flagValue = defaultValue } = ssrLdFlags || {};
  return flagValue;
};

export default useSsrLdFlag;
